import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const InvertAllIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Rounded square outline */}
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Left half filled - represents "selected becomes unselected" */}
      <path
        d="M3 5a2 2 0 0 1 2-2h7v18H5a2 2 0 0 1-2-2V5z"
        fill={color}
      />
      {/* Swap arrows */}
      <path
        d="M8 10l-2 2 2 2"
        stroke={color === 'currentColor' ? '#1a1a1a' : '#ffffff'}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16 10l2 2-2 2"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </BaseIcon>
  ),
);

InvertAllIcon.displayName = 'InvertAllIcon';
